import { ExperienceTypes } from '@/types/gql.generated';
import type { ExperienceTimeFormat } from '@/types/gql.generated';
import { usePageExperienceContextOptional } from '../contexts/PageExperienceContext';

/**
 * The per-view time format to apply, gated to Planner experiences. Returns
 * `undefined` outside a planner context (legacy Page/Schedule, or when there is
 * no experience context at all), so the shared time formatters fall back to
 * their default (12-hour) behavior and the enum never bleeds into the legacy
 * product.
 */
export const useTimeFormat = (): ExperienceTimeFormat | undefined => {
  const context = usePageExperienceContextOptional();

  if (!context) {
    return undefined;
  }

  // A child view always lives under a planner parent; a standalone planner
  // reports its own type. Everything else is the legacy Page/Schedule product.
  const inPlanner =
    context.isChild || context.experience.type === ExperienceTypes.Planner;

  return inPlanner ? context.experience.timeFormat : undefined;
};
